import {createContext} from 'react';

import {DeletedDocumentsStore} from './DeletedDocuments.store';
import Store from './store';

export {default as Store, SortField} from './store';

export {default as CreateDocumentFromTemplateStore} from './CreateDocumentFromTemplate.store';
export {default as MoveDocumentStore} from './MoveDocument.store';

export const StoreContext = createContext<Store>(null!);
export const DeletedContext = createContext<DeletedDocumentsStore>(null!);
